var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { FolderRecommendationService } from '@square/dashboard-protos/models/squareup/sfs/external/services/folder_recommendation/folder_recommendation_service';
import Service, { inject as service } from '@ember/service';
import { computed, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
import { ListRecommendedFoldersRequest } from '@square/dashboard-protos/models/squareup/sfs/external/services/folder_recommendation/list_recommended_folders';
import { get as getFromLocalStorage, set as setToLocalStorage } from '@square/dashboard-utilities/utils/persistable';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { DISMISS_SUCCESS_SMART_FOLDERS_CARD, DISMISS_SMART_FOLDERS_REC_CARD } from '@banking/api/utils/bank-account';
let SmartFolderRecommendationService = (_dec = service('square/experiments'), _dec2 = computed('capitalEngineContext.headers'), _class = class SmartFolderRecommendationService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "squareExperiments", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _initializerDefineProperty(this, "recommendedFolders", _descriptor4, this);
    _initializerDefineProperty(this, "hasDismissedSuccessCard", _descriptor5, this);
    _initializerDefineProperty(this, "hasDismissedRecommendationCard", _descriptor6, this);
    _defineProperty(this, "merchantCategoryCode", '');
  }
  get client() {
    return FolderRecommendationService.create(rpc(apiHostUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  get merchantCategory() {
    return this.merchantCategoryCode;
  }
  get recommendedSmartFolders() {
    return [...this.recommendedFolders];
  }
  dismissSuccessFolderCard() {
    setToLocalStorage(DISMISS_SUCCESS_SMART_FOLDERS_CARD, true, OneTrustConsent.FUNCTIONAL);
    set(this, 'hasDismissedSuccessCard', true);
  }
  dismissRecommendationCard() {
    setToLocalStorage(DISMISS_SMART_FOLDERS_REC_CARD, true, OneTrustConsent.FUNCTIONAL);
    set(this, 'hasDismissedRecommendationCard', true);
  }
  async listRecommendedFolders(owner) {
    const {
      recommendedFolders,
      mcc
    } = await this.client.listRecommendedFolders(ListRecommendedFoldersRequest.create({
      owner
    }));
    set(this, 'recommendedFolders', recommendedFolders);
    set(this, 'merchantCategoryCode', mcc);
    return recommendedFolders;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "squareExperiments", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "recommendedFolders", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasDismissedSuccessCard", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return getFromLocalStorage(DISMISS_SUCCESS_SMART_FOLDERS_CARD) || false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasDismissedRecommendationCard", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return getFromLocalStorage(DISMISS_SMART_FOLDERS_REC_CARD) || false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { SmartFolderRecommendationService as default };